import React, { ReactNode } from "react";
import { Row, Col, Typography } from "antd";

export type LabelForProps = {
  label: ReactNode;
  children?: ReactNode;
  helpText?: string;
  optional?: boolean;
  action?: ReactNode;
};

export const LabelFor: React.FC<LabelForProps> = ({
  label,
  children,
  helpText,
  optional,
  action,
}) => {
  return (
    <Row gutter={[0, 10]}>
      <Col span={24} style={{ fontWeight: 700, fontSize: "14px", lineHeight: "17.57px" }}>
        <Row gutter={8} justify='space-between' style={{ alignItems: "center" }}>
          <Col>
            <Typography.Text
              style={{
                fontSize: 16,
                lineHeight: "18px",
                fontWeight: 400,
                color: "#3F3D56",
                textTransform: "uppercase",
              }}
            >
              {label}
              {optional && (
                <Typography.Text style={{ fontStyle: "italic" }}> (Optional)</Typography.Text>
              )}
            </Typography.Text>
          </Col>
          {action && <Col>{action}</Col>}
        </Row>
      </Col>
      <Col span={24}>{children}</Col>
      {helpText && (
        <Col
          span={24}
          style={{ fontWeight: 400, fontSize: "12px", lineHeight: "15px", color: "#718096" }}
        >
          {helpText}
        </Col>
      )}
    </Row>
  );
};
